export const ConcentricRings = ({ className = '', size = 200, opacity = 0.12 }) => {
  return (
    <svg
      className={`concentric-ring ${className}`}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity }}
    >
      <circle cx="100" cy="100" r="95" stroke="#A8B5B2" strokeWidth="0.5" opacity="0.3" />
      <circle cx="100" cy="100" r="75" stroke="#A8B5B2" strokeWidth="0.5" opacity="0.25" />
      <circle cx="100" cy="100" r="55" stroke="#C9A84C" strokeWidth="0.5" opacity="0.2" />
      <circle cx="100" cy="100" r="35" stroke="#A8B5B2" strokeWidth="0.5" opacity="0.15" />
      <circle cx="100" cy="100" r="15" stroke="#C9A84C" strokeWidth="0.5" opacity="0.3" />
      {/* Cross hairs */}
      <line x1="100" y1="5" x2="100" y2="195" stroke="#A8B5B2" strokeWidth="0.3" opacity="0.1" />
      <line x1="5" y1="100" x2="195" y2="100" stroke="#A8B5B2" strokeWidth="0.3" opacity="0.1" />
      {/* Orbital dots */}
      <circle cx="100" cy="5" r="2" fill="#C9A84C" opacity="0.4" />
      <circle cx="175" cy="100" r="1.5" fill="#A8B5B2" opacity="0.3" />
      <circle cx="55" cy="155" r="1" fill="#C9A84C" opacity="0.25" />
    </svg>
  );
};

export const NestedStar = ({ className = '', size = 80, opacity = 0.15 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity }}
    >
      <polygon
        points="40,5 47,30 75,30 52,47 60,75 40,57 20,75 28,47 5,30 33,30"
        stroke="#C9A84C"
        strokeWidth="0.5"
        fill="none"
        opacity="0.4"
      />
      <polygon
        points="40,18 44,33 60,33 47,42 52,58 40,49 28,58 33,42 20,33 36,33"
        stroke="#A8B5B2"
        strokeWidth="0.5"
        fill="none"
        opacity="0.3"
      />
    </svg>
  );
};
